export default __webpack_public_path__ + "assets/build.00ea7de6.svg";